import React from 'react';
import { Typography } from '@tvg/fuse/typography';
import { MarketingCard } from '@tvg/fuse/marketing-card';
import { getOfferEndDate } from 'utilities/date/date';
import { SiteName } from 'types/Site';
import BrandTypes from 'constants/brand';
import styles from './CreditToAccountCard.module.css';

interface Props {
  site: SiteName;
  offerTitle: string;
  voucherCode: string;
  termLength: number;
  endDate: string;
  nonCreditAccountUser: boolean;
  apr: string;
  onClickCallback: () => void;
}

function CreditToAccount(props: Props) {
  const { apr, voucherCode, endDate, offerTitle, termLength, onClickCallback, nonCreditAccountUser, site } = props;
  const isLittlewoods = site === BrandTypes.LITTLEWOODS;

  return (
    <MarketingCard
      className={styles.card}
      data-testid="credit-to-account-card"
      header={
        <Typography
          color="var(--color-brand-mid)"
          data-testid="credit-to-account-card-heading"
          size={{ xxs: '1', xl: '2' }}
          tag="h2"
          type="heading"
        >
          {offerTitle}
        </Typography>
      }
      paragraphText={
        <>
          <Typography
            data-testid="credit-to-account-card-text-1"
            size={{ xxs: 'm1', xl: '1' }}
            tag="p"
            type="paragraph"
          >
            {isLittlewoods ? (
              <>
                Enter <strong>{voucherCode}</strong> at checkout to order on Buy Now Pay Later and get your credit back
                on this item.
              </>
            ) : (
              <>
                Enter <strong>{voucherCode}</strong> at checkout to order on {termLength} months Buy Now Pay Later, with
                Very Pay and get your credit back.
              </>
            )}
          </Typography>

          <Typography
            data-testid="credit-to-account-card-text-2"
            size={{ xxs: 'm1', xl: '1' }}
            tag="p"
            type="paragraph"
          >
            {isLittlewoods ? (
              <>
                Interest is calculated and compounded daily at a typical rate of 44.9% per annum for the delayed payment
                period and repayment period and is charged to your account at date of order as a lump sum.
              </>
            ) : (
              <>
                Interest is calculated and compounded for the delayed payment period and is added to your account as a
                lump sum when this ends.
              </>
            )}
          </Typography>

          <Typography
            data-testid="credit-to-account-card-text-3"
            size={{ xxs: 'm1', xl: '1' }}
            tag="p"
            type="paragraph"
          >
            {isLittlewoods ? (
              <>
                <strong>Remember, avoid paying all interest</strong> by paying the cash price before the end of the
                delayed payment period. This can be done in one full payment or multiple partial payments.
              </>
            ) : (
              <>
                <strong>Remember, avoid interest</strong> by paying the cash price before the end of the delayed payment
                period, this can be done in one full payment or multiple partial payments.
              </>
            )}
          </Typography>

          <Typography data-testid="credit-to-account-card-end-date" size="m2" type="paragraph" tag="p">
            Offer ends {getOfferEndDate(endDate)}
          </Typography>

          {!isLittlewoods && apr && nonCreditAccountUser && (
            <Typography
              className={styles.apr}
              size="1"
              data-testid="credit-to-account-card-apr"
              tag="p"
              type="paragraph"
            >
              <strong>
                Representative <span>{apr} APR</span> variable
              </strong>
            </Typography>
          )}
        </>
      }
      linkUrl="#"
      linkText="Find out more"
      onClick={onClickCallback}
    />
  );
}

export default CreditToAccount;
